module.exports = __webpack_public_path__ + "media/application/images/playbook-yellow-card-bg-9e4309e252f8f4651e6903f20d8235e7.png";